import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import QRCode from "qrcode";
import PropTypes from "prop-types";

import { useAppStoreUrl, useGooglePlayUrl } from "../../hook/appUrl";
import { downloadUrl, webappURL } from "../../util/url";
import { META_TAG_TITLE } from "../../constants/constants";

import fruitsfamilyLogo from "../../component/appInstallModal/assets/rounded_logo.svg";
import iconStar from "../../component/appInstallModal/assets/ic_yellow_star.svg";
import bgQRBorder from "../../component/appInstallModal/assets/bg_qr_border.svg";
import googleStoreBadge from "../../component/appInstallModal/assets/google_store_download_badge.svg";
import appStoreBadge from "../../component/appInstallModal/assets/app_store_download_badge.svg";

import "./Download.css";

/**
 * Download App page.
 * @param hostname
 */
export default function Download({ hostname }) {
  const appStoreUrl = useAppStoreUrl();
  const googlePlayUrl = useGooglePlayUrl();
  const [qrSvg, setQrSvg] = useState("");

  useEffect(() => {
    QRCode.toString("https://fruitsfamily.app.link/JU10tJPXV8", { type: "svg" })
      .then(setQrSvg)
      .catch(console.error);
  }, []);

  return (
    <section className="Download">
      <Helmet>
        <title>앱 다운로드 | {META_TAG_TITLE}</title>
        <meta
          name="description"
          content="빈티지 세컨핸드 패션 중고거래는 후루츠. 앱에서 후루츠를 제대로 즐겨보세요."
        />
        <link rel="canonical" href={webappURL(hostname) + downloadUrl()} />
      </Helmet>

      <div className="Download-card">
        <h1 className="Download-title">{`앱에서 후루츠를\n제대로 즐겨보세요!`}</h1>

        <div className="Download-qr-background">
          <img
            src={bgQRBorder}
            alt=""
            aria-hidden="true"
            className="Download-qr-border"
          />
          {qrSvg && (
            <div
              className="Download-qr-image"
              role="img"
              aria-label="후루츠 앱 다운로드 QR 코드"
              dangerouslySetInnerHTML={{ __html: qrSvg }}
            />
          )}
        </div>

        <div className="Download-appstore-container">
          <img
            className="Download-logo"
            alt="FruitsFamily™ Logo"
            src={fruitsfamilyLogo}
          />
          <div className="Download-appstore">
            <div className="Download-appstore-text">App Store 평점</div>
            <div className="Download-store-rating">
              <div>4.9</div>
              <div className="Download-store-rating-images" aria-hidden="true">
                <div>
                  <img
                    src={iconStar}
                    alt=""
                    className="Download-store-rating-star"
                  />
                  <img
                    src={iconStar}
                    alt=""
                    className="Download-store-rating-star"
                  />
                  <img
                    src={iconStar}
                    alt=""
                    className="Download-store-rating-star"
                  />
                  <img
                    src={iconStar}
                    alt=""
                    className="Download-store-rating-star"
                  />
                  <img
                    src={iconStar}
                    alt=""
                    className="Download-store-rating-star"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Download-footer">
          <a
            className="Download-link"
            href={appStoreUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={appStoreBadge} alt="App Store에서 다운로드 하기" />
          </a>
          <a
            className="Download-link"
            href={googlePlayUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={googleStoreBadge} alt="Play Store에서 다운로드 하기" />
          </a>
        </div>
      </div>
    </section>
  );
}

Download.propTypes = {
  hostname: PropTypes.string.isRequired,
};